import { ReactComponent as UserActiveIcon } from '../../../assets/icons/sidebar/sidebar-user-active.svg';
import { ReactComponent as UserIcon } from '../../../assets/icons/sidebar/sidebar-user.svg';
import { MenuItem } from '../../../interface/menuItem-interfaces';
import { permissionCheck } from '../../../shared-functions/JWTDocodeFunction';

/**
 * Users Menus List
 * @returns {any} User menu list
 */
const UserMenu = (): MenuItem[] => [
  {
    id: 'settings',
    label: 'settings',
    allow: permissionCheck('userManagementView') || permissionCheck('userRoleManagementView'),
    svgIcon: <UserIcon />,
    activeSvgIcon: <UserActiveIcon />,
    children: [
      {
        id: 'users',
        label: 'user',
        url: '/ev-admin/user-management/user',
        allow: permissionCheck('userManagementView'),
        permissionKey: 'userManagementView',
      },

      {
        id: 'roles',
        label: 'role',
        url: '/ev-admin/user-management/role',
        allow: permissionCheck('userRoleManagementView'),
        permissionKey: 'userRoleManagementView',
      },
    ],
  },
];

export default UserMenu;
